export default __webpack_public_path__ + "static/media/green_base.29d26ad2.png";